<template lang="pug">
  .wrapper-activity-details
    DBLabel(title="nome:", :body="item.activityName")
    DBLabel(title="duração:", :body="floatToHoursMinsString(item.duration)")
    .name
      DBLabel(title="atividade:", :body="item.name")
    DBLabel(title="descrição:", :body="item.description" v-if="item.description")
    .employee
      PMultiSelect(
        v-model="employees"
        useCommon="employees"
        labelItem="name"
        :title="$wp('employee')"
        displayMode
      )
    .companies
      PMultiSelect(
        v-model="companies"
        useCommon="companies"
        labelItem="name"
        :title="$wp('company')"
        displayMode
      )
    .group
      PMultiSelect(
        v-model="groups"
        useCommon="userGroups"
        labelItem="name"
        title="grupos"
        displayMode
      )
    .employers
      PMultiSelect(
        v-model="employers"
        useCommon="employers"
        labelItem="name"
        title="empregadores"
        displayMode
      )
    .buttons
      PButton(color="info" size="md" @click="addOredit(item)" title="editar")
        span.icon-ptt-icons-lapis
      PConfirmButton(text="Excluir esta atividade?" color="danger" size="md" @click="deleteActivityType(item.id)" title="excluir")
        span.icon-ptt-icons-excluir
</template>

<script>
import { floatToHoursMinsString } from 'src/utils'

export default {
  props: {
    item: {type: Object, required: true},
    loading: {type: Boolean, required: true},
    addOredit: {type: Function, required: true},
    deleteActivityType: {type: Function, required: true}
  },
  computed: {
    employees: {
      get () {
        return {
          selected: this.item.employees
        }
      }
    },
    companies: {
      get () {
        return {
          selected: this.item.companies
        }
      }
    },
    groups: {
      get () {
        return {
          selected: this.item.groups
        }
      }
    },
    employers: {
      get () {
        return {
          selected: this.item.employers
        }
      }
    }
  },
  methods: {
    floatToHoursMinsString
  }
}
</script>

<style lang="scss" scoped>
.wrapper-activity-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 30px;

  .name, .employee, .companies, .group, .employers {
    grid-column: 1/3;
  }

  .buttons {
    grid-column: 1/3;
    justify-self: right;
    align-self: end;

    display: grid;
    grid-gap: 2px;
    grid-auto-flow: column;
  }
}
</style>
